import { useHistory } from "react-router-dom";
import * as Styles from "./Teilnehmer.styles";
import TeilnehmerSlider from "./TeilnehmerSlider";

import MainHeader from "../../../components/Wrapper/HealthAnalyseHeader";
import { ANLEGEN } from "routes/routes";

function Teilnehmer() {
  const history = useHistory();
  const handleBtnClick = () => {
    history.push(ANLEGEN);
  };
  return (
    <Styles.Container>
      <div className="main-div">
        <MainHeader
          headline={"Dauerhafte Erfolge"}
          subHeadline={"Über 50.000 erfolgreiche Teilnehmer"}
          handleNextPage={handleBtnClick}
          noBackButton={true}
        />
        <Styles.ContentSection>
          <Styles.TitleWrapper>
            <Styles.Title>Einfache Ernährungsumstellungen.</Styles.Title>
            <Styles.Subtitle>Das sagen unsere Teilnehmer</Styles.Subtitle>

            <Styles.Description>
              Starte mit einem von der Krankenkasse zertifizierten Onlinekurs
              und einer geprüften Ernährungsumstellung, die dir wirklich
              weiterhilft.
            </Styles.Description>
          </Styles.TitleWrapper>
          <Styles.SliderSection>
            <TeilnehmerSlider />
          </Styles.SliderSection>
          <Styles.FoodiaryContent>
            <Styles.RegularTitle>Über Foodiary:</Styles.RegularTitle>
            <Styles.FoodiaryTile>
              <Styles.FoodiaryCircle>
                <p>1</p>
              </Styles.FoodiaryCircle>
              <Styles.FoodiaryContentDiv>
                <Styles.RegularTitle>
                  Mehr als 350 Ernährungscoaches
                </Styles.RegularTitle>
                <Styles.Description>
                  Unsere geprüften Ernährungscoaches unterstützen dich auf
                  deinem Weg.
                </Styles.Description>
              </Styles.FoodiaryContentDiv>
            </Styles.FoodiaryTile>
            <Styles.FoodiaryTile>
              <Styles.FoodiaryCircle>
                <p>1</p>
              </Styles.FoodiaryCircle>
              <Styles.FoodiaryContentDiv>
                <Styles.RegularTitle>
                  Krankenkassen zertifiziert
                </Styles.RegularTitle>
                <Styles.Description>
                  Wissenschaftlich geprüfte und von der Krankenkasse
                  zertifizierte Inhalte.
                </Styles.Description>
              </Styles.FoodiaryContentDiv>
            </Styles.FoodiaryTile>
            <Styles.FoodiaryTile>
              <Styles.FoodiaryCircle>
                <p>1</p>
              </Styles.FoodiaryCircle>
              <Styles.FoodiaryContentDiv>
                <Styles.RegularTitle>100% Geld zurück!</Styles.RegularTitle>
                <Styles.Description>
                  Ernährung umstellen, Ziele erreichen, Erfolge feiern und Geld
                  zurückerhalten.
                </Styles.Description>
              </Styles.FoodiaryContentDiv>
            </Styles.FoodiaryTile>
          </Styles.FoodiaryContent>
        </Styles.ContentSection>
      </div>
      <button
        onClick={handleBtnClick}
        className="btn-dark w-full mt-8 btn-show"
      >
        Ernährungsplan anlegen
      </button>
    </Styles.Container>
  );
}

export default Teilnehmer;
